<template>
    <el-dialog
            title="费用明细"
            :visible.sync="dialogFormVisible"
            :append-to-body="true"
            center
            custom-class="medium-dialog">
        <el-col :span="18">
            <el-form
                    :model="form"
                    ref="form1"
                    :rules="validrules">
                <el-row>
                    <el-col>
                        <el-form-item
                                label="费用类别"
                                :label-width="formLabelWidth"
                                prop="categoryname">
                            <el-input style="width: 150px" v-model="form.categoryname" placeholder="选择费用"
                                      @click.native="selPayType"></el-input>
                            <SelectFeeType
                                    ref="SelectFeeType"
                                    filltemplate="付款"
                                    :parentcategorycode="parentCategoryCode"
                                    @afterSelFeeType="afterSelFeeType"></SelectFeeType>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item
                                label="发生日期"
                                :label-width="formLabelWidth"
                                prop="feedate">
                            <el-date-picker
                                    style="width:150px"
                                    v-model="form.feedate"
                                    :picker-options="feedateOptions"
                                    :value-format="'yyyy-MM-dd'"
                                    type="date"
                                    placeholder="选择日期"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
              <el-row>
                <el-col>
                  <el-form-item
                    label="金额"
                    :label-width="formLabelWidth"
                    prop="feemoney"
                  >
                    <el-input
                      v-model="form.feemoney"
                      style="width: 150px"
                      @focus="feemoneyFocus"
                      @blur="feemoneyBlur"
                      auto-complete="off"
                      :required="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
                <el-row v-if="feeneedfapiao">
                    <el-col>
                        <el-form-item
                                label="是否有发票"
                                :label-width="formLabelWidth"
                                prop="hastickets"
                        >
                            <el-switch
                                    v-model="form.hastickets"
                                    active-text="有"
                                    active-value="1"
                                    inactive-text="无"
                                    inactive-value="0"
                                    active-color="#13ce66"
                                    inactive-color="#DCDCDC">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!--<el-row>-->
                    <!--<el-col>-->
                        <!--<el-form-item-->
                                <!--label="本次应付金额"-->
                                <!--:label-width="formLabelWidth"-->
                                <!--prop="submoney">-->
                            <!--<el-input-->
                                    <!--style="width: 150px"-->
                                    <!--v-model="form.submoney"-->
                                    <!--auto-complete="off"-->
                                    <!--:required="true"></el-input>-->
                        <!--</el-form-item>-->
                    <!--</el-col>-->
                <!--</el-row>-->
                <!--<el-row v-if="feeneedfapiao && (form.hastickets==='1' || form.hastickets===1)">-->
                    <!--<el-col>-->
                        <!--<el-form-item-->
                                <!--label="票据数量"-->
                                <!--:label-width="formLabelWidth"-->
                                <!--prop="ticketsnums">-->
                            <!--<el-input-number-->
                                    <!--v-model="form.ticketsnums"-->
                                    <!--:controls="false"-->
                                    <!--:min="0"-->
                                    <!--:max="10"-->
                                    <!--style="width: 150px"-->
                                    <!--label="票据数量"-->
                            <!--&gt;</el-input-number>-->
                        <!--</el-form-item>-->
                    <!--</el-col>-->
                <!--</el-row>-->
                <el-row v-if="feeneedfapiao && (form.hastickets==='1' || form.hastickets===1)">
                    <el-col>
                        <el-form-item
                                :label="ticketname"
                                :label-width="formLabelWidth"
                                prop="pticketstype">
                            <el-switch v-if="form.tickettotax!='1'"
                                    v-model="form.pticketstype"
                                    active-value="1"
                                    inactive-value="0"
                                    active-color="#13ce66"
                                    inactive-color="#DCDCDC">
                            </el-switch>
                            <el-switch v-if="form.tickettotax=='1'"
                                       v-model="form.tickettotax"
                                       active-value="1"
                                       inactive-value="0"
                                       active-color="#13ce66"
                                       inactive-color="#DCDCDC">
                            </el-switch>
                          <el-tag type="danger" v-if="!(form.pticketstype=='1' || form.tickettotax=='1')&&MustFaPiao">必须使用增值税专票</el-tag>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="feeneedfapiao && (form.pticketstype=='1'||form.tickettotax=='1' ) && (form.hastickets==='1' || form.hastickets===1)">
                    <el-col>
                        <el-form-item
                                label="税率"
                                :label-width="formLabelWidth"
                                prop="JXSPercent">
                            <el-select style="width: 150px"
                                       v-model="jxspercent"
                                       placeholder="请选择">
                                <el-option
                                        v-for="item in jXSPercentData"
                                        :key="item.value"
                                        :label="item.text"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="feeneedfapiao&& (form.pticketstype=='1'||form.tickettotax=='1' )&& (form.hastickets==='1' || form.hastickets===1)">
                    <el-col
                    >
                        <el-form-item
                                label="税额"
                                :label-width="formLabelWidth">
                            <el-input-number
                                    style="width: 150px"
                                    v-model="taxmoney"
                                    auto-complete="off"
                                    :required="true"
                                    :controls="false"
                            ></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
              <FenTanDetailTemplate
                ref="fenTanDetailTemplate"
                :isfentan="form.isfentan"
                :uname="form.uname"
                :uguid="form.uguid"
                :dname="form.dname"
                :dserial="form.dserial"
                :formallowedit="formallowedit"
                :fentanDetailData="form.fentanDetailData"
                :totalFeeMoney="form.feemoney"
              ></FenTanDetailTemplate>
                <el-row>
                    <el-col>
                        <el-form-item
                                label="附件"
                                :label-width="formLabelWidth"
                                prop="attachguidother">
                            <CommonUpload
                                    ref="attachOther"
                                    :multiple="true"
                                    :groupGuid="form.attachguidother"
                                    @afterBind="afterBindOtherTickets" :disabled="!formallowedit"
                                    groupType="payattachother" :showButtonName="'选择附件'"
                                    :limit="10"></CommonUpload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item
                                label="备注"
                                :label-width="formLabelWidth"
                                prop="remark">
                            <el-input
                                    style="width: 80%"
                                    type="textarea"
                                    placeholder=""
                                    v-model="form.remark"
                                    :autosize="{ minRows: 2, maxRows: 20}"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-col>
        <el-col :span="6">
            <el-menu
                    :default-active="defaultactive"
                    active-text-color="#409EFF"
                    class="elmenuclass"
                    @select="selMenu">
                <el-menu-item
                        v-for="(ticket, index) in tableDataFee"
                        :index="ticket.unitguid"
                        :key="ticket.unitguid">
                    <div slot="title"> {{ticket.feedate.substr(0,10)}}
                    </div>
                    <div slot="title">{{ticket.categoryname}} {{ticket.submoney}}
                    </div>
                </el-menu-item>
            </el-menu>
        </el-col>
        <span slot="footer" class="dialog-footer" >
      <el-button
              v-if="formallowedit"
              type="primary"
              @click="saveData('close')"
      >保存</el-button>
      <el-button
              v-if="formallowedit && form.flag"
              type="primary"
              @click="saveData('continue')"
      >再加一张</el-button>
      <el-button @click="dialogFormVisible = false">关 闭</el-button>
    </span>
    </el-dialog>
</template>
<style scope>
    .elmenuclass div {
        height: 25px;
        line-height: 25px;
    }

    .elmenuclass {
        border-right: solid 0px #e6e6e6;
        border-left: solid 1px #e6e6e6;
        list-style: none;
        position: relative;
        margin: 0;
        margin-left: 5px;
    }
</style>
<script>
    import {attUUID} from "@/api/attachment";
    import {getListNoPage} from "@/api/set/Category";
    import {saveData, getDetail} from "@/api/pay/paydetail";
    import SelectFeeType from "./SelectFeeType";
    import FenTanDetailTemplate from './FenTanDetailTemplate'

    export default {
      name: "paydetailedit",
      props: [
        "parentCategoryCode",
        "parentCategoryName",
        "tableDataFee",
        "payGuid",
        "formallowedit",
      ],
      data() {
        return {
          oldFeeMoney: '',
          feedateOptions: {
            disabledDate(time) {
              return time.getTime() > Date.now();
            },
          }, dialogFormVisible: false,
          feeneedfapiao: true,//从属性中获取是否需要发票
          MustFaPiao: false,
          defaultactive: "", //票据标签默认选中的
          ticketcount: 0,
          otherattachcount: 0,
          ticketname: "增值税专票",
          form: {
            //定义表单参数（不要在这里赋默认值 统一在initForm中初始化）
            unitguid: "",
            uanme: "",
            uguid: "",
            dserial: "",
            dname: "",
            summary: "",
            paymoney: "", //上级部门编码
            casestatus: "", //上级部门
            casestepname: "",
            hastickets: "",
            ticketsnums: 1,
            feemoney: 0,
            taxmoney: "",
            jxspercent: "",
            hasattach: 0,
            attachguid: "",
            categoryname: "",
            categorycode: "",
            feedate: "",
            pticketstype: "",
            submoney: "",
            formtype: "",
            remark: "",
            ticketdisplayinfo: "",
            ticketocrinfo: "",
            flag: "",
            tickettotax: "",//车票抵扣进项税
            ticketno: "",//发票号码
            fentanDetailData: "[]",//分摊明细
            isfentan: '0',//是否分摊
            fentanmoney: '0',//分摊总额
          },
          jXSPercentData: [], //进项税率
          isHeTong: false,
          isPayStep: false, //是否付款步骤
          formLabelWidth: "120px",
          validrules: {
            feemoney: [
              {required: true, message: "请输入金额", trigger: "blur"},
              {pattern: /^\d+(.\d{1,2})?$/, message: "必须是数字，且小数点保留2位"}
            ],
            // submoney: [
            //   {required: true, message: "请输入票据金额", trigger: "blur"},
            //   {pattern: /^\d+(.\d{1,2})?$/, message: "必须是数字，且小数点保留2位"}
            // ],
            categoryname: [
              {required: true, message: "请选择费用类别", trigger: "change"}
            ],
            feedate: [
              {required: true, message: "请选择发生日期", trigger: "blur"}
            ]
          },
          feemoney: "",
          jxspercent: "",
          taxmoney: "",
          tableData: []
        };
      },
      watch: {
        jxspercent: function () {
          if (this.form.feemoney && this.jxspercent) {
            this.taxmoney = (parseFloat(this.form.feemoney) - parseFloat(
              this.form.feemoney / (1 + parseFloat(this.jxspercent))
            )).toFixed(2);
          } else {
            this.taxmoney = "";
          }
        }
      },
      methods: {
        addPage(param) {
          this.initForm();
          this.defaultactive = "";
          // this.form.attachguid = attUUID();//发票电子件
          this.form.attachguidother = attUUID();//其他附件
          this.form.hastickets = "1"; //默认有发票
          this.form.ticketcount = 0;//发票附件数量
          this.form.otherattachcount = 0;//其他附件数量
          this.form.hasattach = 0;//总的附件数量
          this.form.categorycode = param.feecode;
          this.form.categoryname = param.feename;
          this.feeneedfapiao = param.needfapiao;
          this.MustFaPiao = param.MustFaPiao;
          //配置了车票抵扣进项税
          if (param.tickettotaxpercent) {
            this.ticketname = "可抵扣增值税";
            this.form.tickettotax = "1";
            this.jxspercent = param.tickettotaxpercent;
            this.form.jxspercent = param.tickettotaxpercent;
          }

          this.form.formtype = "ZF"; //报销单BX;付款单ZF;备用金申请单
          var userinfo = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
          this.form.uname = userinfo.uname;
          this.form.uguid = userinfo.uguid;
          this.form.dserial = userinfo.dserial;
          this.form.dname = userinfo.dname;
          var today = new Date();
          this.form.adddate =today.getFullYear() +"-" +(today.getMonth() + 1) +"-" +today.getDate();
          //初始化分摊记录
          this.$nextTick(() => {
            this.$refs.fenTanDetailTemplate.initOffset();
          });
        },
        //选择费用
        selPayType() {
          this.$refs.SelectFeeType.addPage();
        },
        //选择费用后，更新明细
        afterSelFeeType() {
          //选择的大类编码和名称
          this.form.categorycode = this.$refs.SelectFeeType.selCategoryCode;
          this.form.categoryname = this.$refs.SelectFeeType.selCategoryName;
          this.feeneedfapiao = this.$refs.SelectFeeType.needfapiao;
          this.MustFaPiao = this.$refs.SelectFeeType.MustFaPiao;
          this.tickettotaxpercent = this.$refs.SelectFeeType.tickettotaxpercent;
        },
        initForm() {
          for (var key in this.form) {
            this.form[key] = "";
          }
          if (this.$refs.treeFeeType != undefined) {
            this.$refs.treeFeeType.reset();
          }
          this.feeneedfapiao = true;
          this.MustFaPiao = false;
          this.form.isfentan = '0';
          this.form.fentanDetailData = "[]";
          this.form.categoryname = "";
          this.form.ticketsnums = "1";
          this.taxmoney = "";
          this.feemoney = "";
          this.jxspercent = "";
          //下面开始给默认字段赋值
          this.dialogFormVisible = true;
          this.form.flag = true;
        },
        editPage(unitguid) {
          this.initForm();
          this.form.flag = false; //修改状态下 flag=false
          getDetail({unitguid: unitguid}).then(response => {
            this.defaultactive = unitguid;
            this.form = response.data.obj;
            this.form.hastickets = this.form.hastickets.toString();
            if (this.form.pticketstype) {
              this.form.pticketstype = this.form.pticketstype.toString();
            }
            this.taxmoney = this.form.taxmoney;
            this.feemoney = this.form.feemoney;
            this.jxspercent = this.form.jxspercent;
            this.form.isfentan = this.form.isfentan?this.form.isfentan.toString():"0";
            //初始化分摊记录
            this.$nextTick(() => {
              this.$refs.fenTanDetailTemplate.initOffset();
            });
            //获取费用配置的属性（是否需要发票）
            getListNoPage({
              categorycode: this.form.categorycode,
              filltemplate: "付款",
              categorytype: 100
            }).then(result => {
              if (result.data.obj.length) {
                var formproperty = JSON.parse(result.data.obj[0].formproperty);
                for (var item in formproperty) {
                  if (formproperty[item].name == "需要发票") {
                    this.feeneedfapiao = formproperty[item].item;
                  } else if (formproperty[item].name == "必须使用增值税专票") {
                    this.MustFaPiao = formproperty[item].item;
                  }
                }
              }
            })
          });
        },
        deleteData() {
          //删除方法
          deleteData({unitguid: this.form.unitguid}).then(response => {
            if (response.data.code === 0) {
              this.$message({
                message: "删除成功！",
                type: "success"
              });
              this.dialogFormVisible = false;
              //刷新列表
              this.$emit("bindFeeGrid", this.payGuid);
            } else {
              this.$message({
                message: response.data.msg,
                type: "error"
              });
            }
          });
        },
        //savetype:保存类型，close：保存并关闭，continue：保存并继续
        saveData(savetype) {
          if (this.form.flag) {
            //录入时间由后台添加
            this.form.adddate = "";
          }
          if (!this.feeneedfapiao) {//不需要发票的
            this.form.hastickets = '0';
          }
          var fentanDetailjson = this.$refs.fenTanDetailTemplate.fentanDetailjson;
          this.form.isfentan = this.$refs.fenTanDetailTemplate.iffentan;
          //是分摊
          if (this.form.isfentan == '1'&&fentanDetailjson) {
            var checkApply = true;
            this.form.fentanDetailData = JSON.stringify(this.$refs.fenTanDetailTemplate.fentanDetailjson);
            var totalFentanFee = 0;
            fentanDetailjson.forEach(element => {
              totalFentanFee += parseFloat(element.fentanmoney || 0);
              if (element.applybydguid == "") {
                checkApply = false;
                return;
              }
            });
            if (!checkApply) {
              this.$message({
                message: "请选择分摊人员",
                type: "error"
              });
              return;
            }

            if (totalFentanFee > parseFloat(this.form.feemoney)) {
              this.$message({
                message: "分摊总额不能大于费用金额",
                type: "error"
              });
              return;
            }
            this.form.fentanmoney = totalFentanFee.toFixed(2);
          }
          else {
            this.form.fentanDetailData = "[]";
            this.form.fentanmoney = '0'
          }

          this.form.taxmoney = this.taxmoney;
          this.form.jxspercent = this.jxspercent;
          this.$refs.form1.validate(valid => {
            if (valid) {
              saveData(this.form, this.form.flag).then(response => {
                if (response.data.code === 0) {
                  this.$message({
                    message: response.data.msg,
                    type: "success"
                  });
                  //刷新列表
                  this.$emit("bindFeeGrid", this.payGuid);
                  if (savetype == "close") {
                    //保存并关闭
                    this.dialogFormVisible = false;
                  } else {
                    // this.form.attachguid = attUUID();
                    this.form.attachguidother = attUUID();//其他附
                    this.form.hastickets = "1"; //默认有发票
                    this.form.ticketsnums = "1";
                    this.taxmoney = "";
                    this.feemoney = "";
                    this.jxspercent = "";
                    this.form.feemoney = 0;
                    this.form.taxmoney = "";
                    this.form.jxspercent = "";
                    this.form.hasattach = 0;
                    this.form.ticketcount = 0;//发票附件数量
                    this.form.otherattachcount = 0;//其他附件数量
                    this.form.feedate = "";
                    this.form.pticketstype = "";
                    this.form.submoney = 0;
                    this.form.remark = "";
                    this.form.ticketdisplayinfo = "";
                    this.form.ticketocrinfo = "";
                    this.form.flag = true;
                  }
                } else {
                  this.$message({
                    message: response.data.msg,
                    type: "error"
                  });
                }
              });
            }
          });
        },
        //点击其他票据，进行切换
        selMenu(index, indexPath) {
          if (index == "1") index = "";
          this.editPage(index);
        },
        afterBindTicket(fileList) {
          this.ticketcount = fileList.length;
          this.form.hasattach = this.otherattachcount + this.ticketcount;
        },
        afterBindOtherTickets(fileList) {
          this.otherattachcount = fileList.length;
          this.form.hasattach = this.otherattachcount + this.ticketcount;
        },
        feemoneyFocus() {
          this.oldFeeMoney = this.form.feemoney;
        },
        //金额变化后事件
        feemoneyBlur() {
          var patt = /^[0-9]*$/;
          if (this.oldFeeMoney == this.form.feemoney)
            return;//金额没有发生改变 不触发

          if (patt.test(this.form.feemoney)) {
            //输入的是数字
            if (this.form.feemoney && this.jxspercent) {
              this.taxmoney = (parseFloat(this.form.feemoney) - parseFloat(
                this.form.feemoney / (1 + parseFloat(this.jxspercent))
              )).toFixed(2);
            } else {
              this.taxmoney = "";
            }
            this.form.submoney = this.form.feemoney;
          }
        },
      },
      components: {
        SelectFeeType, //选择费用类别
        FenTanDetailTemplate
      },
      mounted() {
        this.jXSPercentData = [];
        for(let i=0;i<=6;i++){
          this.jXSPercentData.push({text:i+'%',value:(i*0.01).toString()});
        }
        this.jXSPercentData.push({text:'9%',value:(0.09).toString()});
        this.jXSPercentData.push({text:'12%',value:(0.12).toString()});
        this.jXSPercentData.push({text:'13%',value:(0.13).toString()});
        this.jXSPercentData.push({text:'16%',value:(0.16).toString()});
      }
    };
</script>



// WEBPACK FOOTER //
// src/components/oa/payform/PaydetailEdit_FuKuan.vue